import { render, staticRenderFns } from "./DocumentPickerModal.vue?vue&type=template&id=9c2bff2c"
import script from "./DocumentPickerModal.vue?vue&type=script&lang=js"
export * from "./DocumentPickerModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPickerModal.vue?vue&type=style&index=0&id=9c2bff2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports